import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        radio: css`
            width: 100%;
            justify-content: flex-start;
            display: flex;
            flex-direction: row;
            white-space: nowrap;
            padding-left: 0 !important;
            padding-right: 0 !important;
        `,
        radioRoot: css`
            padding: 1px 3px !important;
        `,
        radioSmall: css`
            font-size: ${theme.typography.button.fontSize}px !important;
            margin-right: ${theme.spacing(0)};
            margin-left: 0 !important;
        `,
        formControlStyle: css`
            margin-left: ${theme.spacing(-0.625)};
        `,
        showInColumns: css`
            flex-direction: column;
        `,
        radioItemLabel: css``,
        label: css`
            color: ${theme.palette.secondary[400]};
            white-space: nowrap;
            padding-top: ${theme.spacing(1)}px;
            display: block;
        `,
    }
}

export default styles
